(function () {
  'use strict';

  var section = document.querySelector('#pdp-qcg-modul-auswahl-section');
  if (!section) return;

  var cardsWrappers = section.querySelectorAll('.pdp-qcg-modul-auswahl__wrapper');

  cardsWrappers.forEach(function (cardsWrapper) {
    cardsWrapper.addEventListener('click', function (event) {
      // Prevent closing when clicking inside Dynamic-Card-Expanded-Bottom-Wrapper
      if (event.target.closest('.Dynamic-Card-Expanded-Bottom-Wrapper')) {
        return;
      }

      var card = event.target.closest('.Dynamic-Card');
      if (card) {
        var cardExpandableContent = card.querySelector('.Dynamic-Card-Expanded-Wrapper');
        var chevron = card.querySelector('.Dynamic-Card-Expand-Chevron');
        var button = card.querySelector('.Dynamic-Card-Show-Button');
        var buttonText = button.querySelector('span');

        var isModuleCardOpen = cardExpandableContent.classList.contains('open');

        var openModuleCards = cardsWrapper.querySelectorAll('.Dynamic-Card-Expanded-Wrapper.open');
        openModuleCards.forEach(function (openModuleCard) {
          openModuleCard.style.maxHeight = null;
          openModuleCard.classList.remove('open');
          var moduleCard = openModuleCard.closest('.Dynamic-Card');
          var openButton = moduleCard.querySelector('.Dynamic-Card-Show-Button');
          var openChevron = openButton.querySelector('.Dynamic-Card-Expand-Chevron');
          var openButtonText = openButton.querySelector('span');

          // Fade out text before changing
          openButtonText.style.opacity = 0;
          setTimeout(function () {
            openButtonText.textContent = 'Mehr erfahren';
            openButtonText.style.opacity = 1;
          }, 150);

          openButton.classList.remove('omr-button-secondary--neutral');
          openButton.classList.add('omr-button-secondary--color');
          openChevron.style.transform = 'rotate(90deg)';
          moduleCard.style.gap = '0px';
        });

        if (!isModuleCardOpen) {
          cardExpandableContent.style.maxHeight = cardExpandableContent.scrollHeight + 'px';
          cardExpandableContent.classList.add('open');

          // Fade out text before changing
          buttonText.style.opacity = 0;
          setTimeout(function () {
            buttonText.textContent = 'Weniger anzeigen';
            buttonText.style.opacity = 1;
          }, 150);

          button.classList.remove('omr-button-secondary--color');
          button.classList.add('omr-button-secondary--neutral');
          chevron.style.transform = 'rotate(-90deg)';
          card.style.gap = window.innerWidth >= 320 && window.innerWidth <= 767 ? '24px' : '32px';
        }
      }
    });
  });
})();
